import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet, NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './admin-layout.component.html',
  styles: [`
    .sidebar-link {
      @apply flex items-center gap-3 px-4 py-3 text-sm font-serif transition-all duration-300 rounded-sm;
    }
    .sidebar-link-active {
      @apply bg-btn text-white shadow-md;
    }
    .sidebar-link-inactive {
      @apply text-section/70 hover:bg-white/10 hover:text-white;
    }
  `]
})
export class AdminLayoutComponent implements OnInit {
  isSidebarOpen = true;
  isMobile = false;
  today = new Date();

  constructor(
    public authService: AuthService, 
    private router: Router
  ) {
    this.checkScreenSize();
  }

  ngOnInit() {
    // Close sidebar on mobile after navigation
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (this.isMobile) {
        this.isSidebarOpen = false;
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isMobile = window.innerWidth < 1024; // lg breakpoint
    if (this.isMobile) {
      this.isSidebarOpen = false;
    } else {
      this.isSidebarOpen = true;
    }
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  logout() {
    this.authService.logout();
  }
}
